import { POST, GET, ip } from './api'

export {
    POST,
    GET,
    ip
}